import React from "react";
import { dumpNewGm6 } from "src/services/storage";

export const NewGm6 = () => {
  function backToNormal() {
    dumpNewGm6("0");
    window.location.reload();
  }
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        position: "relative",
      }}
    >
      <iframe
        src="https://beta.gm6.com.br"
        title="beta.gm6.com.br"
        style={{ width: "100%", height: "100vh", border: "none" }}
      />
      <div className="newgm6button">
        <span onClick={backToNormal}>Voltar à versão anterior</span>
      </div>
    </div>
  );
};
